<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <edit-profile-form
            :user="user"
            :distributors="distributors"
            @update="updateProfile"
          ></edit-profile-form>
        </div>
        <div class="col-md-4">
          <user-card :user="user" :distributors="distributors"></user-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiErrors from '@/mixins/api-errors';
import EditProfileForm from './UserProfile/ProfileForm.vue';
import UserCard from './UserProfile/Card.vue';

export default {
  components: {
    EditProfileForm,
    UserCard,
  },
  data() {
    return {
      user: {},
      distributors: [],
      roles: ['ADMIN', 'DEVELOPER', 'USER'],
    };
  },
  mixins: [apiErrors],
  created() {
    this.getDistributors();
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http
        .get('auth/user')
        .then((res) => {
          if (res && res.data && res.data.user) {
            this.user = res.data.user;
          }
        })
        .catch(this.apiErrorCallback);
    },
    getDistributors() {
      this.$http
        .get('distributor')
        .then((res) => {
          if (res && res.data && res.data.body) {
            this.distributors = res.data.body;
          }
        })
        .catch(this.apiErrorCallback);
    },
    updateProfile(user) {
      this.$http
        .put(`user/${this.user._id}`, user)
        .then((res) => {
          if (res && res.data && res.data.user) {
            this.$notify({
              title: this.$t('common.messages.successfullyUpdated'),
              type: 'success',
            });
            this.user = res.data.user;
          }
        })
        .catch(this.apiErrorCallback);
    },
  },
};
</script>
<style></style>
